import React from 'react';
import { Box, Stack } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import HelpPanelButton from '@atlassian/jira-help-panel-button';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { Link } from '@atlassian/react-resource-router';
import messages from './messages';

type Props = {
	intl: IntlShape;
};

function DeprecationMessage(props: Props) {
	const {
		intl: { formatMessage },
	} = props;

	return (
		<SectionMessage appearance="discovery" title={formatMessage(messages.deprecationTitle)}>
			<Stack space="space.150" alignBlock="start">
				<Box>{formatMessage(messages.legacyAutomationDeprecationBody)} </Box>
				<Box>
					<HelpPanelButton
						articleId="7uoLaS9fT3bxUQjfuaFbcG"
						appearance="link"
						spacing="none"
						fallbackComponent={
							<Link
								href="https://support.atlassian.com/jira-service-desk-cloud/docs/what-is-legacy-automation/"
								target="_blank"
							>
								{formatMessage(messages.legacyAutomationIPHLink)}
							</Link>
						}
					>
						{formatMessage(messages.legacyAutomationIPHLink)}
					</HelpPanelButton>
				</Box>
				<Box>{formatMessage(messages.automationBody)} </Box>
				<Box>
					<HelpPanelButton
						articleId="2UlFyf7lrr0tDs8X49kVov"
						appearance="link"
						spacing="none"
						fallbackComponent={
							<Link
								href="https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-automation/"
								target="_blank"
							>
								{formatMessage(messages.automationIPHLink)}
							</Link>
						}
					>
						{formatMessage(messages.automationIPHLink)}
					</HelpPanelButton>
				</Box>
			</Stack>
		</SectionMessage>
	);
}

export default injectIntl(DeprecationMessage);
